export class SubscriptionOptions extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['purchaseOption', 'sellingPlan']
  }

  setupListeners () {
    super.setupListeners()

    this.update = this.update.bind(this)
    this.updateSubmitText = this.updateSubmitText.bind(this)

    this.els.purchaseOption.elements.forEach((radio) => {
      this.listeners.add(radio, 'change', this.update)
    })

    if (this.frequency) {
      this.listeners.add(this.frequency, 'change', this.update)
    }

    this.listeners.add(
      window.BAO.eventBus,
      window.BAO.EVENTS.PRODUCT.OPTION_SELECTED,
      this.updateSubmitText,
    )

    this.update()
  }

  /**
   * @returns {void}
   */
  update () {
    this.els.purchaseOption.elements.forEach((radio) => {
      radio
        .closest('[data-subscription-option]')
        .classList.toggle('prd-BundlePicker_Option-selected', radio.checked)
    })

    this.els.sellingPlan.element.value =
      this.isSubscription && this.frequency ? this.frequency.value : ''

    this.updateSubmitText()
  }

  /**
   * @returns {void}
   */
  updateSubmitText () {
    const submitText = this.externalEls.submitText

    if (!submitText || !submitText.exists) return

    submitText.elements.forEach((el) => {
      const { textOnetime, textSubscription } = el.dataset

      if (textOnetime == null || textSubscription == null) return

      const button = el.closest('button')

      if (button && button.disabled) return

      el.textContent = this.isSubscription ? textSubscription : textOnetime
    })
  }

  /**
   * @returns {HTMLSelectElement|null}
   */
  get frequency () {
    return this.els.frequency?.element || null
  }

  /**
   * @returns {boolean}
   */
  get isSubscription () {
    return this.els.purchaseOption.elements.some(
      (radio) => radio.checked && radio.value === 'subscription',
    )
  }
}

if (!customElements.get('bao-subscription-options')) {
  customElements.define('bao-subscription-options', SubscriptionOptions)
}
